import React, { useState, useEffect, useRef, useCallback } from "react";
import Button from "@mui/material/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Stella.css";
import { stellaRealDummyData } from "../assets/stellaRealDummyData";
import { Helmet } from "react-helmet";
import { Grid } from "@mui/material";
import { TbSend } from "react-icons/tb";

function StellaTestingJourney() {
  const stsic_alternamte_journey = new URLSearchParams(
    new URL(window.location.href).search
  ).get("journey");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [stellaDummyJsonData, setStellaDummyJsonData] = useState([]);
  const [stellaQuestionToAsk, setStellaQuestionToAsk] = useState([]);
  const [userResponse, setUserResponse] = useState("");
  const [stellaJsonQuestion, setStellaJsonQuestion] = useState([]);
  const [responseMessage, setresponseMessage] = useState("");
  const [stellaResponseToSendToServer, setStellaResponseToSendToServer] = useState([]);
  const [showAssesmentScore, setShowAssesmentScore] = useState(false);
  const chatHistoryRef = useRef(null);
  const [completedTask, setCompletedTask] = useState(false);
  const [loadingQuestion, setLoadingQuestion] = useState(true);
  const [showInputBox, setShowInputBox] = useState(false);
  const [stellaChatHistory, setStellaChatHistory] = useState([]);
  const [responseButton, setResponseButton] = useState("");
  const [interpretations, setInterpretations] = useState({});
  const [scrollDisable, setScrollDisable] = useState(true);

  useEffect(() => {
    if (
      stsic_alternamte_journey === undefined ||
      stsic_alternamte_journey === null
    ) {
      setStellaDummyJsonData(stellaRealDummyData[0]);
    } else {
      setStellaDummyJsonData(
        stellaRealDummyData?.find(
          (item) => item.journey === stellaRealDummyData
        )
      );
    }
  }, []);

  useEffect(() => {
    if (stellaDummyJsonData && stellaDummyJsonData.questions) {
      const formattedQuestions = stellaDummyJsonData.questions.map((q) => ({
        ...q,
        category: q.category || "Uncategorized",
      }));

      setStellaJsonQuestion(formattedQuestions);
      setCurrentQuestionIndex(0);
    }
  }, [stellaDummyJsonData]);

  useEffect(() => {
    if (stellaJsonQuestion.length > 0) {
      const questionId_to_display =
        stellaJsonQuestion[currentQuestionIndex]?.question_id;
      if (questionId_to_display !== undefined) {
        setStellaQuestionToAsk([]);
        setTimeout(() => {
          setLoadingQuestion(false);
          setStellaQuestionToAsk(
            stellaJsonQuestion.find(
              (item) =>
                Number(item.question_id) === Number(questionId_to_display)
            )
          );
        }, 2000);
        setLoadingQuestion(true);
      }
      if (
        stellaJsonQuestion[stellaJsonQuestion.length - 1]?.question_id ===
        stellaQuestionToAsk?.question_id
      ) {
        setStellaQuestionToAsk([]);
        setCompletedTask(true);
        setShowAssesmentScore(true);
      } else if (
        stellaQuestionToAsk?.options !== undefined &&
        stellaQuestionToAsk?.send_response === true
      ) {
        setCompletedTask(true);
      } else {
        setCompletedTask(false);
      }
    }
  }, [currentQuestionIndex, stellaJsonQuestion]);

  useEffect(() => {
    if (stellaQuestionToAsk.question_type === "Long-Text") {
      if (responseMessage && responseMessage.trim() !== "") {
        const questionObject = {
          question: stellaQuestionToAsk?.question,
          response: responseMessage,
          question_type: stellaQuestionToAsk?.question_type,
        };
        setStellaResponseToSendToServer((prevArray) => [
          ...prevArray,
          questionObject,
        ]);

        const chatHistoryObject = {
          question: stellaQuestionToAsk,
          response: responseMessage,
          question_type: stellaQuestionToAsk?.question_type,
        };
        setStellaChatHistory((prevArray) => [...prevArray, chatHistoryObject]);
        setShowInputBox(false);
        setresponseMessage(" ");
      } else {
        setShowInputBox(true);
      }
    } else {
      if (responseButton && responseButton !== " ") {
        const questionObject = {
          question: stellaQuestionToAsk?.question,
          response: responseButton?.text,
          value: responseButton.score,
          question_id: stellaQuestionToAsk?.question_id,
          question_type: stellaQuestionToAsk?.question_type,
        };
        setStellaResponseToSendToServer((prevArray) => [
          ...prevArray,
          questionObject,
        ]);

        const chatHistoryObject = {
          question: stellaQuestionToAsk,
          response: responseMessage === " " ? responseButton : responseMessage,
        };
        setStellaChatHistory((prevArray) => [...prevArray, chatHistoryObject]);
        setresponseMessage(" ");
      }
    }
  }, [responseMessage, responseButton]);

  useEffect(() => {
    if (stellaQuestionToAsk?.question_type === "Long-Text") {
      const alreadyAnswered = stellaChatHistory.some(
        (item) =>
          item.question?.question_id === stellaQuestionToAsk?.question_id
      );
      setShowInputBox(!alreadyAnswered);
    } else {
      setShowInputBox(false);
    }
  }, [stellaQuestionToAsk, stellaChatHistory]);

  const handleMultiSelectButton = (data) => {
    setResponseButton(data);
  };

  useEffect(() => {
    if (responseMessage === " ") {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      setUserResponse("");
    }
  }, [responseMessage, responseButton]);

  const sendApiResponse = async () => {
    console.log(stellaResponseToSendToServer," send response");
    const longTextResponses = stellaResponseToSendToServer.filter(
      (item) => item.question && item.question_type === "Long-Text"
    );
    const actualCategoryScores = calculateCategoryScores();

    const Payload = {
      data: stellaDummyJsonData,
      responses: longTextResponses,
      interpretation_scores: interpretations,
      category_scores: actualCategoryScores,
      record_id:
        localStorage.getItem("record_id") !== null &&
        localStorage.getItem("record_id") !== undefined
          ? parseInt(localStorage.getItem("record_id"))
          : -1,
    };

    try {
      const response = await fetch("https://integrations.uwc.world/stella-sa/v1", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Payload),
      });
      if (response.status === 200) {
        const data = await response.json();
        console.log(" API Called Successfully:", data);
      } else {
        console.error(" API call failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error calling Dummy API:", error);
    }
  };

  useEffect(() => {
    if (completedTask) {
      sendApiResponse();
      setCompletedTask(false);
    }
  }, [completedTask]);

  const handleSendButton = () => {
    if (userResponse.trim() !== "") {
      setresponseMessage(userResponse);
      onEnterClicked();
      setUserResponse("");
    }
  };

  const onEnterClicked = () => {
    setresponseMessage(userResponse);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && userResponse !== "") {
      onEnterClicked();
      setUserResponse("");
    }
  };

  const handleTextChange = (e) => {
    setUserResponse(e.target.value);
  };

  const calculateCategoryScores = useCallback(() => {
    const categoryScores = {
      Gains: 0,
      Engagement: 0,
      "Enhanced functioning": 0,
      Balance: 0,
    };

    stellaChatHistory.forEach((item) => {
      if (item?.question?.add_score) {
        categoryScores[item.question.category] += item.response.score;
      }
    });

    return categoryScores;
  }, [stellaChatHistory]);

  const getInterpretation = (score) => {
    if (score >= 5 && score <= 11) return "Low";
    if (score >= 12 && score <= 18) return "Moderate";
    if (score >= 19 && score <= 25) return "High";
  };

  const getSuggestion = useCallback((category, score) => {
    const interpretationsArray = stellaDummyJsonData?.interpretations;

    if (
      !Array.isArray(interpretationsArray) ||
      interpretationsArray.length === 0
    ) {
      console.error("Interpretations data is missing or not an array.");
      return "No suggestion available.";
    }

    const interpretations = interpretationsArray[0]?.[category] || {};
    const interpretationKey = getInterpretation(score);
    return interpretations[interpretationKey] || "No suggestion available.";
  }, [stellaDummyJsonData]);

  useEffect(() => {
    const categoryScores = calculateCategoryScores();
    const newInterpretations = {};

    for (const [category, score] of Object.entries(categoryScores)) {
      newInterpretations[category] = getSuggestion(category, score);
    }
    setInterpretations(newInterpretations);
  }, [stellaChatHistory, calculateCategoryScores, getSuggestion]);


  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
  }, [stellaChatHistory]);

  return (
    <>
      <Helmet>
        <title>Talk to Stella | United We Care</title>
      </Helmet>
      {window.scrollTo(0, 0)}
      <div className="min-h-screen stella-screen mb-5 pb-5">
        <div className="chat-box">
          <div className="chat-box--header">
            <Button
              className="StellaAvatar--Selector"
              sx={{ minWidth: "max" }}
              // onClick={handleClickOpenDialog}
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fopen%2Fstella%2Ffaces%2F1.png?alt=media"
                width={60}
                height={60}
                alt="My Avatar"
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  objectPosition: "center top",
                }}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M11.9984 22.0914C17.3004 22.0914 21.5984 17.7933 21.5984 12.4914C21.5984 7.18942 17.3004 2.89136 11.9984 2.89136C6.6965 2.89136 2.39844 7.18942 2.39844 12.4914C2.39844 17.7933 6.6965 22.0914 11.9984 22.0914Z"
                  fill="#541CF5"
                  stroke="white"
                  strokeWidth="1.90119"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 8.49146V16.4915"
                  stroke="white"
                  strokeWidth="1.02981"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 12.4917H16"
                  stroke="white"
                  strokeWidth="1.02981"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Button>

            <div className="chat-box--logo">
              <p>Stella</p>
            </div>
          </div>

          <div className="chat-box--content container">
            <div ref={chatHistoryRef} className="chat-content--chats" >
              <div className="response-area">
                <div style={{ width: "100%" }} className="space-y-5">
                  <div className="d-flex align-items-start gap-2">
                    <div className="avatar">
                      <img
                        src="https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fopen%2Fstella%2Ffaces%2F1.png?alt=media"
                        alt="My Avatar"
                      />
                    </div>
                    <div className="static-response">
                      <div className={`response server-response mb-2`}>
                        {stellaDummyJsonData?.expert_info}
                      </div>
                      <div className={`response server-response mb-2`}>
                        {stellaDummyJsonData?.opening_details}
                      </div>
                    </div>
                  </div>

                  {stellaChatHistory &&
                    stellaChatHistory?.map((item, index) => (
                      <div key={index}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <div className="d-flex align-items-start gap-2">
                              <div className="avatar">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fopen%2Fstella%2Ffaces%2F1.png?alt=media"
                                  alt="My Avatar"
                                />
                              </div>
                              <div className={`response server-response`}>
                                {item?.question?.question}
                                {item?.question?.options?.map((button) => (
                                  <div
                                    key={button?.button_id}
                                    className="response-buttons"
                                  >
                                    <div className="button--item">
                                      {button?.text}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={12} align="right">
                            <div
                              className="response my-response"
                              style={{
                                // marginRight: "50px",
                                textAlign: "start",
                              }}
                            >
                              {/* {item?.response} */}
                              {item?.question?.question_type === "Long-Text"
                                ? item.response
                                : item.response?.text}
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    ))}

                  {stellaJsonQuestion[stellaJsonQuestion.length - 1]
                    ?.question_id >= stellaQuestionToAsk?.question_id && (
                    <>
                      {[stellaQuestionToAsk]?.map((item) => (
                        <div
                          className="d-flex align-items-start gap-2"
                          key={item?.id}
                        >
                          <div className="avatar">
                            <img
                              src="https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fopen%2Fstella%2Ffaces%2F1.png?alt=media"
                              alt="My Avatar"
                            />
                          </div>
                          <div className={`response server-response`}>
                            {item?.question}
                            {item?.options?.map((button) => (
                              <div
                                className="response-buttons"
                                key={button?.button_id}
                                onClick={() => handleMultiSelectButton(button)}
                              >
                                <div className="button--item">
                                  {button?.text}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </>
                  )}

                  {showAssesmentScore && (
                    <div className="d-flex align-items-start gap-2">
                          <div className="avatar">
                            <img
                              src="https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fopen%2Fstella%2Ffaces%2F1.png?alt=media"
                              alt="My Avatar"
                            />
                          </div>
                      <div
                        style={{ marginTop: "15px" }}
                        className={`response server-response`}
                      >
                        <div>
                          <h5>Recommendations</h5>
                          {Object.entries(interpretations).map(
                            ([category, interpretation], index) => (
                              
                              <div key={category}>
                                <p style={{ marginTop: "15px" }}>
                                  {category} :
                                </p>
                                <p style={{ marginTop: "15px" }}>
                                  {interpretation}
                                </p>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {loadingQuestion && (
                <div id="wave-animation" style={{ marginLeft: "50px" }}>
                  <div id="loading-bubble" className="grey">
                    <div className="spinner">
                      <div className="bounce1"></div>
                      <div className="bounce2"></div>
                      <div className="bounce3"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {showInputBox && (
              <div className="chat-content--input">
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="text"
                    value={userResponse}
                    placeholder="Start Typing..."
                    onChange={(e) => handleTextChange(e)}
                    onKeyDown={handleKeyPress}
                    disabled={
                      stellaQuestionToAsk?.question_type === "single_select"
                    }
                    className="border rounded-4"
                  />
                  <button
                    className="send-input--button"
                    onClick={handleSendButton}
                    disabled={userResponse === ""}
                  >
                    <TbSend className="fs-3" />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StellaTestingJourney;
